export const routeConfig = {
  meta: {
    title: '系统设置',
  },
  redirect: '/set/role',
  params: ':type([a~z]*)?'
};
